// extracted by mini-css-extract-plugin
export default {"parent":"style_parent__onw-L","child1":"style_child1__OlCvU","child2":"style_child2__9KvQS","content":"style_content__ctRjM"};